import Api from "../../Api";

export const getAgencies=async()=>{
    try {
        let res = await Api.get("/agency-master");
        return (res?.data || [])
    }
    catch (e) {
        console.log(e);
        return ([])
    }
}